interface CustomIconWhatsAppSharingProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconWhatsAppSharing({
  width,
  height,
  className,
  color = '#1C1C28',
}: CustomIconWhatsAppSharingProps) {
  return (
    <svg
      className={className}
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18258_60637)">
        <path
          d="M24.9769 6.17354C22.82 4.01143 19.9475 2.82227 16.8948 2.82227C10.5938 2.82227 5.46646 7.94956 5.46646 14.2506C5.46646 16.2634 5.99155 18.2299 6.99024 19.9647L5.85976 24.0918C5.64155 24.8885 6.3678 25.6225 7.16671 25.4127L11.4277 24.2941C13.0956 25.2053 14.9746 25.684 16.8896 25.684H16.8948C23.1906 25.684 28.4312 20.5567 28.4312 14.2557C28.4312 11.203 27.1339 8.33565 24.9769 6.17354ZM16.8948 23.7587C15.1857 23.7587 13.5126 23.3006 12.0558 22.4357L11.7108 22.2298L8.11762 23.1719L9.07513 19.6661L8.84862 19.3058C7.89626 17.7923 7.39692 16.0472 7.39692 14.2506C7.39692 9.01517 11.6594 4.75272 16.8999 4.75272C19.4378 4.75272 21.8213 5.74112 23.6128 7.53773C25.4042 9.33434 26.5059 11.7178 26.5007 14.2557C26.5007 19.4963 22.1302 23.7587 16.8948 23.7587ZM22.1044 16.6443C21.8213 16.5002 20.4159 15.8104 20.1534 15.7177C19.8908 15.6199 19.7004 15.5736 19.5099 15.8619C19.3194 16.1501 18.7737 16.7885 18.6039 16.9841C18.4391 17.1746 18.2693 17.2003 17.9861 17.0562C16.3079 16.2171 15.2063 15.5581 14.0995 13.6586C13.806 13.1541 14.3929 13.1901 14.9386 12.0988C15.0312 11.9083 14.9849 11.7436 14.9128 11.5994C14.8408 11.4553 14.2693 10.0499 14.0325 9.47848C13.8009 8.92251 13.5641 8.99973 13.3891 8.98943C13.2243 8.97914 13.0339 8.97914 12.8434 8.97914C12.6529 8.97914 12.344 9.05121 12.0815 9.33434C11.819 9.62262 11.0828 10.3124 11.0828 11.7178C11.0828 13.1232 12.1072 14.4822 12.2462 14.6727C12.3904 14.8632 14.2591 17.746 17.1264 18.9866C18.9385 19.7691 19.6489 19.836 20.5549 19.7022C21.1057 19.6198 22.2434 19.0124 22.4802 18.3431C22.717 17.6739 22.717 17.1025 22.645 16.9841C22.578 16.8554 22.3876 16.7833 22.1044 16.6443Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_18258_60637">
          <rect width="23.0625" height="26.3572" fill="white" transform="translate(5.36865 2.82227)" />
        </clipPath>
      </defs>
    </svg>
  );
}
